// Discord Activity context detection.
//
// Discord serves an activity through its proxy at {application_id}.discordsays.com,
// so the hostname both identifies the context AND carries the client id. That
// means no build-time env var and no extra round trip to learn who we are -
// which matters because the client id is needed before the SDK can be built.

const ACTIVITY_HOST_SUFFIX = ".discordsays.com";

export function isDiscordActivity(): boolean {
  return window.location.hostname.endsWith(ACTIVITY_HOST_SUFFIX);
}

export function getActivityClientId(): string | null {
  const host = window.location.hostname;
  if (!host.endsWith(ACTIVITY_HOST_SUFFIX)) return null;
  const id = host.slice(0, -ACTIVITY_HOST_SUFFIX.length);
  // Snowflakes are all digits; anything else means the host shape changed and
  // we should fail visibly rather than hand garbage to the SDK.
  return /^\d+$/.test(id) ? id : null;
}
